/**
 * By default, Emotion passes all props (except for theme) to custom components.
 *
 * We decided on a convention to prefix props that should not be passed to the component with a `$`.
 */
export function shouldForwardProp(propName: string): boolean {
  return !propName.startsWith('$')
}
